/**
 * Check if the device has a camera and if permission can be granted
 * @returns Promise resolving to boolean indicating camera availability
 */
export const checkCamera = async (): Promise<boolean> => {
  // First check if mediaDevices is supported
  if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    console.error('mediaDevices API or getUserMedia not supported in this browser')
    return false
  }

  // Set constraints for rear camera (environment) if available
  const constraints = {
    video: {
      facingMode: 'environment',
      width: { ideal: 1280, max: 1920 }
    }
  }

  try {
    // Request camera access
    const stream = await navigator.mediaDevices.getUserMedia(constraints)

    // Check if we actually got video tracks
    if (stream.getVideoTracks().length === 0) {
      console.warn('No video tracks found in the media stream')
      return false
    }

    // Release camera immediately
    stream.getTracks().forEach((track) => track.stop())
    return true
  } catch (error) {
    console.error('Camera access error:', error)

    // Try with simpler constraints as fallback
    try {
      // Some devices might work with simpler constraints
      const simpleStream = await navigator.mediaDevices.getUserMedia({ video: true })
      simpleStream.getTracks().forEach((track) => track.stop())
      return true
    } catch (fallbackError) {
      console.error('Camera access fallback also failed:', fallbackError)
      return false
    }
  }
}
